import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { fetchUserData } from "../../services/UserService";
import toast from "react-hot-toast";

const initialState:any = {
   isLoading: false,
   error: null,
   userCartDetails:{},
   orderPageID:0
   
};
export const fetchUserCartDetails:any= createAsyncThunk(
  "/user",
  async (token: any) => {
    const response = await fetchUserData(token);
    return response.data; 
  }
);
export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
   
    emptyCart: (state) => {
      state.userCartDetails = {};
    },
    setUserDetails: (state, action) => {
      state.userCartDetails = action.payload; 
    },
    setOrderPageID:(state, action) => {
      state.orderPageID = action.payload; 
    },
  },
 
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserCartDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        
      })
      .addCase(fetchUserCartDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userCartDetails = action.payload; 
        
      })
      .addCase(fetchUserCartDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to fetch cart details";
        localStorage.removeItem("token");
        localStorage.removeItem("product_ids");

        console.error("Fetch cart details failed:", action.error);
      });
  },
});

// Export the action creator generated by createSlice
export const { emptyCart,setUserDetails,setOrderPageID}: any =
  userSlice.actions;

// Export the reducer function generated by createSlice
export default userSlice.reducer;
